import React, { Suspense, lazy } from 'react'
import { useTranslation } from 'react-i18next'
import './notFound.scss'
const Loader = lazy(() => import('components/ui-kit/Loader/index'))

const NotFoundComponent = () => {
  const { t } = useTranslation()
  return (
    <Suspense fallback={<Loader />}>
      <div className='pt-5 static-root page-not-found bg-container'>
        <h2 className='text-center'>
          <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 24 24'
            fill='currentColor'
            className='w-4 h-4 mr-2'
            aria-hidden='true'
          >
            <path d='M12 2.5L1.5 21h21L12 2.5zm0 5.2 6.8 11.3H5.2L12 7.7zM11 10v5h2v-5h-2zm0 6.5v2h2v-2h-2z' />
          </svg>
          {t('404')}
        </h2>
        <div className='mt-3 notFound text-center'>
          <p>
            {t('pageNotFound')}
          </p>
        </div>
      </div>
    </Suspense>
  )
}
export default React.memo(NotFoundComponent)
